import { render, staticRenderFns } from "./modal-upload-photo.vue?vue&type=template&id=16d15ab4"
import script from "./modal-upload-photo.vue?vue&type=script&lang=js"
export * from "./modal-upload-photo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports